import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import get from 'lodash/get';
import { Flex, Box, Text } from 'roo-ui/components';
import Image from 'components/Image';
import { mediaQuery } from 'lib/styledSystem';

const InfoBox = styled(Box)`
  margin-bottom: ${themeGet('space.6')};
  border: ${themeGet('borders.2')};
  border-color: ${themeGet('colors.greys.alto')};
  padding: ${themeGet('space.3')};
  text-align: center;
  color: ${themeGet('colors.greys.charcoal')};
  border-radius: ${themeGet('radii.default')};
`;

const OfferImage = styled(Image)`
  height: 75px;
  width: 100%;
  border-radius: ${themeGet('radii.default')};
  margin: 0 0 ${themeGet('space.3')} 0;

  ${mediaQuery.minWidth.sm} {
    margin: 0 ${themeGet('space.6')} 0 0;
    width: 110px;
  }
`;

const OfferDetails = ({ roomType, children }) => {
  const { name, mainImage } = roomType;
  const urlMedium = get(mainImage, 'urlMedium', '');
  const urlLarge = get(mainImage, 'urlLarge', '');
  const caption = get(mainImage, 'caption', '');
  const propertyImageSrcSet = mainImage ? `${urlLarge} 2x, ${urlMedium} 1x` : undefined;

  return (
    <InfoBox>
      <Flex alignItems={['flex-start', 'center']} flexDirection={['column', 'row']}>
        <OfferImage lazy src={urlMedium} alt={caption} srcSet={propertyImageSrcSet} />
        <Flex flexDirection="column" flex="1 1 0%" alignItems="flex-start" justifyContent="center">
          <Text fontSize="base" fontWeight="bold" data-testid="classic-roomtype">
            {name}
          </Text>
          <Text fontSize="sm" color="greys.steel">
            Classic Reward Offer
          </Text>
        </Flex>
        <Box maxWidth="200px" mr={8} data-testid="classic-card-description">
          {children}
        </Box>
      </Flex>
    </InfoBox>
  );
};

OfferDetails.propTypes = {
  roomType: PropTypes.shape({
    name: PropTypes.string,
    mainImage: PropTypes.object,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export default OfferDetails;
